// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"area_wrapper__2ZsZC","title":"area_title__1Thi0"};